<template>
  <div class="basic_wrap">
    <van-row class="topLogoItem">
      <van-col span="24" class="logoLang">
        <img src="../images/common/logo.png" style="width: 130px" />

        <p class="languageList" @click="$router.push('/language')">
          <span style="padding: 0px 4px" class="ActiveLanguage">EN</span>/<span
            style="padding: 0px 4px"
            >CN</span
          >
        </p>
      </van-col>
    </van-row>
    <form class="form">
      <div>
        <van-row>
          <van-col span="24">
            <div class="registerTopic">
              <p class="registerTopicP">{{ $t("register.signUp") }}</p>
            </div>
          </van-col>
        </van-row>
        <!-- ---------- name ------ -->
        <van-row style="margin-top: 30px">
          <van-col span="24"
            ><p class="labelText">{{ $t("register.username") }}:</p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon">
            <img src="../images/register/username.png" alt="" />
          </span>
          <input type="text" class="inp" v-model.trim="data.username" />
        </div>
        <!-- ---------- phone number ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">{{ $t("register.mobile") }}:</p></van-col
          >
        </van-row>
        <div class="item">
          <!-- <span class="icon">
            <img src="../images/login/tel.png" alt="" />
          </span>
          <input type="text" class="inp" /> -->
          <div
            class="icon"
            @click="showCountryPicker = true"
            style="border-right: 1px solid #969799"
          >
            <img
              :src="countryFlagUrl"
              style="height: 18px; width: auto; margin-right: 5px"
            />
            <span :v-model="countryCode" style="white-space: nowrap">{{
              countryCode
            }}</span>
          </div>
          <!-- Removed v-model.trim -->
          <input type="text" class="inp" v-model="mobile" />
        </div>
        <!-- ---------- password ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">{{ $t("register.password") }}:</p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon"
            ><img src="../images/register/password.png" alt=""
          /></span>
          <input :type="password" class="inp" v-model.trim="data.password" />
          <div
            class="eye_bi"
            @click="showPwd"
            :class="password == 'text' ? 'eye' : ''"
          ></div>
        </div>
        <!-- ---------- re password ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">{{ $t("register.rePassword") }}:</p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon"
            ><img src="../images/register/password.png" alt=""
          /></span>
          <input :type="spassword" class="inp" v-model.trim="data.spassword" />
          <div
            class="eye_bi"
            @click="showRePwd"
            :class="spassword == 'text' ? 'eye' : ''"
          ></div>
        </div>
        <!-- ---------- sms code ------ -->
        <!-- <div v-if="show_sms > 0"> -->
        <div>
          <van-row style="margin-top: 15px">
            <van-col span="24"
              ><p class="labelText">{{ $t("register.code") }}:</p></van-col
            >
          </van-row>
          <div class="item">
            <span class="icon"
              ><img src="../images/register/OTP.png" alt=""
            /></span>
            <input type="text" class="inp" v-model.trim="data.code" />
            <van-count-down
              :time="time"
              class="btn get_code"
              @finish="timeCall"
            >
              <template v-slot="timeData">
                <span @click="sendcode">{{
                  timeData.seconds > 0
                    ? timeData.seconds
                    : $t("register.sendCode")
                }}</span>
              </template>
            </van-count-down>
          </div>
        </div>
        <!-- ---------- email ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">{{ $t("register.phoneNumber") }}:</p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon">
            <img src="../images/register/email.png" alt="" />
          </span>
          <input type="text" class="inp" v-model.trim="data.email" />
        </div>
        <!-- ---------- refferral code ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">
              {{ $t("register.referralCode") }}:
            </p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon"
            ><img src="../images/register/refcode.png" alt=""
          /></span>
          <input type="text" class="inp" v-model.trim="data.reid" />
        </div>
        <!-- ------- register submit button ------- -->
        <van-row style="margin-top: 20px">
          <van-col
            span="24"
            style="display: flex; align-items: center; justify-content: center"
          >
            <div
              type="submit"
              class="register_btn sbtn"
              :class="
                data.mobile == '' || data.password == '' ? 'no_touch' : ''
              "
              @click="submit"
            >
              {{ $t("register.signUpBtn") }}
            </div>
          </van-col>
        </van-row>
        <!-- -------- divider ----------- -->
        <van-divider
          :style="{ borderColor: '#ffffff', padding: '30px 20px 0px' }"
        >
        </van-divider>
        <van-row style="padding-top: 20px">
          <van-col span="24" style="text-align: center">
            <p style="font-size: 13px; color: #ffffff">
              {{ $t("register.haveAccount") }}
              <router-link to="/login"
                ><span style="color: #f3da2f">{{
                  $t("register.loginHere")
                }}</span></router-link
              >
            </p>
          </van-col>
        </van-row>
        <!-- --------- Terms & Conditions and Privacy Policy ------- -->

        <van-row style="margin: 45px 0px">
          <router-link to="/info/user_agreement">
            <van-col span="12" class="termPrivacyItem">
              <van-badge dot class="badgeDot"> </van-badge>
              <p class="termsPrivacy">{{ $t("register.conditions") }}</p>
            </van-col>
          </router-link>
          <router-link to="/info/privacy_policy">
            <van-col span="12" class="termPrivacyItem">
              <van-badge dot class="badgeDot"> </van-badge>
              <p class="termsPrivacy">{{ $t("register.policy") }}</p>
            </van-col>
          </router-link>
        </van-row>
      </div>
    </form>
    <van-popup v-model="showCountryPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="countryCodeList"
        @confirm="onConfirm"
        @cancel="showCountryPicker = false"
        :confirm-button-text="$t('bottomSheet.confirmPopup')"
        :cancel-button-text="$t('bottomSheet.cancelPopup')"
      />
    </van-popup>

    <van-dialog
      v-model="statement"
      confirm-button-color="#fb661e"
      :close-on-click-overlay="true"
      @click="privacyStatementHide"
    >
    </van-dialog>
    <van-dialog
      v-model="agreement"
      confirm-button-color="#fb661e"
      :close-on-click-overlay="true"
      @click="agreementHider"
    >
    </van-dialog>
    <!-- <div
      v-if="msg_show"
      class="kefu"
      :class="show_kefu ? '' : 'kefu_hide'"
      @click="kefu_to"
    >
      <img class="kefu_img" src="../images/index/kefu.png" />
    </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import {
  Popup,
  Picker,
  CountDown,
  Checkbox,
  Dialog,
  Col,
  Row,
  Divider,
  Badge,
} from "vant";
import Fetch from "../../utils/fetch";

Vue.use(CountDown)
  .use(Checkbox)
  .use(Dialog)
  .use(Row)
  .use(Col)
  .use(Divider)
  .use(Badge)
  .use(Popup)
  .use(Picker);

export default {
  name: "Register",
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      time: 0,
      agreement: false,
      statement: false,
      show_kefu: false,
      msg_show: true,
      show_sms: 0,
      password: "password",
      spassword: "password",
      data: {
        username: "",
        phonenumber: "",
        password: "",
        spassword: "",
        mobile: "",
        reid: "",
        code: "",
      },
      config: {},
      showCountryPicker: false,
      mobile: "",
      countryCode: "",
      countryCodeList: [],
      countryCodesResponse: [],
      countryFlagUrl: "",
    };
  },
  created() {
    // this.$parent.footer("user", false);
    this.getparams();
    // 安卓返回IMEI，苹果返回UID值
    /*BSL.PhoneID('callName');
			window.callName = this.methodName;
			// 获取手机OAID
			BSL.GetOAID('getExternalInfo');
			window.getExternalInfo = this.getExternalInfoData; */
  },
  mounted() {
    if (this.$route.query.reid) {
      localStorage.setItem("agent", this.$route.query.reid);
      this.data.reid = this.$route.query.reid;
    } else {
      if (localStorage.getItem("agent")) {
        this.data.reid = localStorage.getItem("agent");
      }
    }
    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );
    Fetch("/index/webconfig", { type: "web" }).then((res) => {
      this.config = res.data;
      this.show_sms = res.data.sms;
    });
    this.getCountryCodes();
  },
  methods: {
    onConfirm(value, index) {
      this.countryFlagUrl = this.countryCodesResponse[index].flag;
      this.countryCode = value;
      this.showCountryPicker = false;
    },
    kefu_to() {
      if (this.show_kefu) {
        this.$router.push("/kefu");
      }
      this.show_kefu = !this.show_kefu;
    },
    showPwd() {
      if (this.password == "password") {
        this.password = "text";
      } else {
        this.password = "password";
      }
    },
    showRePwd() {
      if (this.spassword == "password") {
        this.spassword = "text";
      } else {
        this.spassword = "password";
      }
    },
    methodName(r) {
      this.data.imei = r;
    },
    getExternalInfoData(info) {
      var info = JSON.parse(info);
   
      if (info.code == 0) {
        this.data.oaid = info.oaid;
      }
    },
    getparams() {
      var m = this.$route.query.m;
      this.data.t_mobile = m;
    },
    timeCall() {
      this.is_send = false;
      this.time = 0;
    },
    sendcode() {
      if (this.is_send) {
        return;
      }
      this.data.mobile = this.countryCode + this.mobile;

      if (!this.data.mobile) {
        this.$toast(this.$t("register.phoneEmpty"));
        return;
      }

      this.is_send = true;
      this.data.code = "";

      Fetch("/user/register_code", {
        mobile: this.data.mobile,
      })
        .then(() => {
          this.time = 60 * 1000;
          this.$toast({
            background: "#07c160",
            message: this.$t("register.sendSuccess"),
          });
        })
        .catch(() => {
          this.is_send = false;
        });
    },
    submit() {
    
      if (!this.mobile) {
        this.$toast(this.$t("register.phoneEmpty"));
        return false;
      }
      if (!this.data.password) {
        this.$toast(this.$t("register.passwordEmpty"));
        return false;
      }

      if (!this.data.spassword) {
        this.$toast(this.$t("register.passwordAgainEmpty"));
        return false;
      }

      if (!this.data.code && this.config.sms) {
        this.$toast(this.$t("register.codeEmpty"));
        return false;
      }

      if (this.data.password != this.data.spassword) {
        this.$toast(this.$t("register.passwordNotMatch"));
        return false;
      }

      this.data.mobile = this.countryCode + this.mobile;
      Fetch("/user/register", {
        ...this.data,
      }).then((res) => {
        if (res.data.token) {
          localStorage.setItem("token", res.data.token);
        }
        this.$toast(this.$t("register.signUpSuccess"));
        this.$router.replace("/");
      });
    },
    userAgreement() {
      this.agreement = true;
    },
    agreementHider() {
      this.agreement = false;
    },
    privacyStatement() {
      this.statement = true;
    },
    privacyStatementHide() {
      this.statement = false;
    },
    getCountryCodes() {
      Fetch("/Phone/phonenum_country").then((r) => {
        this.countryCodesResponse = r.data;
        if (this.countryCodesResponse.length > 0) {
          this.countryFlagUrl = this.countryCodesResponse[0].flag;
          this.countryCode = this.countryCodesResponse[0].phone_code;
          r.data.forEach((item) => {
            this.countryCodeList.push(item.phone_code);
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
#app {
  padding-bottom: 45px !important;
}

.basic_wrap {
  background: url(../images/startpage/splashBg.png);
  background-size: 100% 100%;
  // height: 100vh;
}

.topLogoItem {
  align-items: center;
  display: flex;
  padding: 20px;
  padding-top: 50px;
  position: relative;
}

.logoLang {
  align-items: center;
  display: flex;
}

.languageList {
  color: #ffffff;
  font-size: 15px;
  border: 1px solid #ffffff;
  padding: 5px 2px;
  border-radius: 5px;
  width: 75px;
  right: 12px;
  position: absolute;
  text-align: center;
}

.form {
  padding: 20px;
  margin-top: 100px;
}

.item {
  height: 46px;
  border: 1px solid #ffffff;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 9px;
  border-radius: 20px;
  background: #d4dddfde;

  .icon {
    width: 70px;
    height: 27px;
    padding-left: 10px;
    display: flex;
    align-items: center;
    .people {
      width: 23px;
      height: 20px;
    }

    img {
      width: 27px;
      height: 27px;
    }
  }

  input {
    height: 20px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
  }
}

.get_code {
  height: 38px;
  line-height: 48px;
  font-size: 12px;
  color: #247575;
  margin-right: 10px;
  font-weight: 700;
}

.register_btn {
  height: 50px;
  line-height: 46px;
  font-size: 24px;
  width: 100%;
  background: unset;
  border-radius: 15px;
  color: #ffffff;
  text-align: center;
  border: 1px solid #ffffff;
  margin-top: 20px;
}

// ======== new design ======
.registerTopic {
  text-align: center;
}

.registerTopicP {
  font-size: 32px;
  padding: 8px;
  color: #ffffff;
  font-weight: 700;
}

.labelText {
  color: #ffffff;
  padding: 4px 10px;
  font-size: 14px;
}

.eye_bi {
  margin-right: 10px !important;
}

.termsPrivacy {
  font-size: 12px;
  line-height: 16px;
  padding-left: 10px;
  color: #ffffff;
}

.termPrivacyItem {
  display: flex;
  justify-content: center;
  align-items: center;
}

.badgeDot {
  background-color: #ffffff;
  width: 7px;
  height: 7px;
}

.ActiveLanguage {
  color: #f3da2f;
}

input:-webkit-autofill,
input:-webkit-autofill:focus {
  transition: background-color 600000s 0s, color 600000s 0s;
}
</style>
